module.exports = __webpack_public_path__ + "img/bg-sphere.63cc408c.svg";